<template>
    <iframe
        class="bng-covid"
        v-if="session && url"
        :src="url"
        allow="autoplay; fullscreen"
        allowfullscreen="true"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
    ></iframe>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'covid',
    data() {
        return {
            backRoute: '/virtual-sports'
        };
    },
    computed: {
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        lang() {
            return Vue.state.lang.currentLang;
        },
        backUrl() {
            return this.backRoute ? `${window.location.protocol}//${window.location.host}${this.backRoute}` : null;
        },
        session() {
            return Vue.state.covid.session.get();
        },
        url() {
            return this.session.url;
        }
    },
    watch: {
        async lang() {
            await this.closeSession();
            await this.openSession();
        }
    },
    async created() {
        await Vue.state.player.ensure();
        await this.openSession();
    },
    methods: {
        async openSession() {
            if (this.isLoggedIn) {
                await Vue.state.covid.session.open(this.lang);
            } else {
                await Vue.state.covid.session.openDemo(this.lang);
            }
        },
        async closeSession() {
            await Vue.state.covid.session.close();
        }
    },
    async beforeDestroy() {
        if (this.session) {
            await Vue.state.covid.session.close();
        }
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/covid/covid.vue